export class NameValue {
  public name: string;
  public value: any;

  public constructor(itemName?: string, itemValue?: any) {
    if (itemName == null || itemName == undefined) {
      this.name = '';
    } else {
      this.name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.value = null;
    } else {
      this.value = itemValue;
    }
  }
}
